import React from "react";
import { Workout } from "@/types";
import {
  Controller,
  FormProvider,
  useFormContext
} from "react-hook-form";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Separator } from "@/components/ui/separator";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useGetMembersListQuery } from "@/services/memberApi";
import { MultiSelect } from "@/components/ui/multiselect/multiselectCheckbox";
import { useUpdateWorkoutMutation } from "@/services/workoutApi";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@/components/ui/common/loading-button";
import { toast } from "@/components/ui/use-toast";


interface AssignWorkoutMembersProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  workout_id: number | null;
}

const AssignWorkoutMembers = ({
  isOpen,
  setOpen,
  workout_id,
}: AssignWorkoutMembersProps
) => {
  const form = useFormContext<Workout>();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = form;


  const navigate = useNavigate();
  const orgId =
    useSelector((state: RootState) => state.auth.userInfo?.user?.org_id) || 0;
  const { data: memberList } = useGetMembersListQuery({
    id: Number(orgId),
    query: "",
  });


  const [
    updateWorkout,
    { isLoading, isError: workoutUpdateError },
  ] = useUpdateWorkoutMutation();

  const onSubmit = async (payload: Workout) => {
    if (!workout_id) return;
    console.log({ payload })
    let resp;

    if (workout_id) {
      resp = await updateWorkout({ id: workout_id, ...payload, org_id: Number(orgId) }).unwrap();

      if (resp && resp.workout_id) {
        toast({
          variant: "success",
          description: `Members assigned successfully`,
        });
        navigate(
          `/admin/workoutplans`
        );
      } else {
        toast({
          variant: "destructive",
          description: `Failed to create workout`,
        });
      }

    }
  }

  return (
    <Sheet open={isOpen} onOpenChange={() => {
      setOpen(false)
      navigate("/admin/workoutplans");
    }}>
      <SheetContent
        className="bg-formbg  p-0 custom-scrollbar !h-full "
      >
        <SheetHeader className="px-6 sticky top-0  py-3  bg-white">
          <SheetTitle>Assign Members</SheetTitle>
        </SheetHeader>
          <Separator className=" h-[1px] rounded-full mb-2" />
        <SheetDescription className=" px-3 py-2">
          <FormProvider {...form}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="bg-white rounded-lg flex flex-col p-3 gap-4"
              noValidate
            >
              <Controller
                name="members"
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { invalid, error },
                }) => (
                  <MultiSelect
                    floatingLabel="Assign Members"
                    key="Assign Members"
                    options={memberList || []}
                    defaultValue={value || []} // Ensure defaultValue is always an array
                    onValueChange={(selectedValues) => onChange(selectedValues)}
                    placeholder="Assign Members"
                    variant="inverted"
                    maxCount={1}
                    className="focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                  />
                )}
              />
              <LoadingButton
                type="submit"
                className="bg-primary text-black text-center flex items-center gap-2"
                loading={isLoading}
                disabled={isLoading}
              >
                {!isLoading && (
                  <i className="fa-regular fa-floppy-disk text-base px-1 "></i>
                )}
                Save
              </LoadingButton>
            </form>
          </FormProvider>
        </SheetDescription>

      </SheetContent>
    </Sheet>
  )
};

export default AssignWorkoutMembers;